import React from 'react';

import FooterContainer from 'containers/footer/FooterContainer';
import { default as Navbar } from 'containers/navbar/NavbarContainer';

import vicfalls_3 from 'assets/img/stock/vfalls/vfalls_3.jpg';

export default () =>
    <div className="fullheight">
        <Navbar className="dark_start" />

        <section className="boxes themeBG">
            <div className="container-fluid">
                <div className="row">
                    <div
                        className="col-md-12 bordered_block grey_border image_bck m-t-120 p-t-30"
                        data-image={vicfalls_3}
                    >
                        <div
                            className="over"
                            data-opacity="0.5"
                            data-color="#292929"
                        />
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 wow fadeInLeft">
                                    <span className="great_title">
                                        Victoria Falls
                                    </span>
                                    <span className="great_subtitle great_subtitle_big">
                                        Mosi-oa-tunya
                                    </span>
                                    <br />
                                    <span className="into_txt" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-10 col-md-offset-1">
                        <table className="table table-bordered table-striped dark-text">
                            <thead>
                                <tr>
                                    <th>Schedule</th>
                                    <th>Activities</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Arrival night</td>
                                    <td>
                                        <ul>
                                            <li>
                                                Wellness, relaxation parlour
                                            </li>
                                            <li>
                                                Dinner : Victoria Falls Hotel:
                                                Main dining hall
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2">
                                        <b>1st night</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td>First half of the day</td>
                                    <td>
                                        <ul>
                                            <li>
                                                Victoria Falls National park
                                                Dawn game drive
                                            </li>
                                            <li>Victoria Falls tour</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Second half of the day</td>
                                    <td>
                                        <ul>
                                            <li>
                                                Lunch: Zambezi River Sunset
                                                cruises
                                            </li>
                                            <li>
                                                Dinner: Victoria Falls Safari
                                                Lodge Dinner and Waterhole Game
                                                overlook
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2">
                                        <b>2nd night</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <ul>
                                            <li>
                                                Flight of Angels over the falls
                                            </li>
                                            <li>Lunch</li>
                                            <li>
                                                Snake Park, Curio and Artifact
                                                Shopping,{' '}
                                            </li>
                                            <li>Afternoon Rest and Siesta</li>
                                            <li>
                                                Hwange National Park Sunset
                                                Safari
                                            </li>
                                            <li>Dinner: Hwange Safari Lodge</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2">
                                        <b>3rd night</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <ul>
                                            <li>
                                                Choice of: Bungee jumping, white
                                                water rafting, zip line,
                                                devils’s pool, Zambia excursion,
                                                self-directed activities or rest
                                            </li>
                                            <li>
                                                Dinner at the BOMA restaurant
                                                (traditional & local cuisine)
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <b>4th day</b>
                                    </td>
                                    <td>departure</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
        <FooterContainer />
    </div>;



// WEBPACK FOOTER //
// ./src/pages/itinerary/vicfalls/VicfallsItinerary.jsx